import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store, { projectPhases } from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Toast from 'bootstrap-vue/es/components/toast'

Vue.use(BootstrapVue)
Vue.use(Toast)
Vue.config.productionTip = false
Vue.prototype.$serverAddr = window.location.protocol + '//fss.navel.pro/api'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

store.dispatch('loadUser', localStorage.getItem('userId'))
store.dispatch('loadUsers')

Vue.prototype.$getPhaseColorByName = function (name) {
  return projectPhases.find(phase => phase.name === name).color
}

Vue.prototype.$getCurrentPhase = function (phases) {
  /*
   current phase is simply last phase
   */
  if (phases.length > 0) {
    return phases[phases.length - 1]
  }
  return null

  /*
   current phase depending on date
   make no sense to push project to next phase, because projects will automatically be pushed
   */

  // let now = (new Date()).getTime()
  // for (let phase of phases) {
  //   let start = Date.parse(phase.start_date)
  //   let end = Date.parse(phase.end_date) + 1000 * 60 * 60 * 24
  //
  //   if ((now > start && now <= end)) {
  //     return phase
  //   }
  // }
  // return null
}
